<div class="pl" #racine (click)="hideTooltip()">

  <!-- Période et résumé -->
  <div class="pl-toolbar">
    <div class="pl-nav">
      <button type="button" class="btn btn-outline-secondary pl-nav-btn" (click)="decaler(-7)" [disabled]="loading"
        aria-label="Semaine précédente" title="Semaine précédente">
        <i class="material-icons-outlined" aria-hidden="true">chevron_left</i>
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="allerAujourdhui()" [disabled]="loading">Aujourd'hui</button>
      <button type="button" class="btn btn-outline-secondary pl-nav-btn" (click)="decaler(7)" [disabled]="loading"
        aria-label="Semaine suivante" title="Semaine suivante">
        <i class="material-icons-outlined" aria-hidden="true">chevron_right</i>
      </button>
    </div>

    <form class="pl-period" (ngSubmit)="load()">
      <label class="pl-field">
        <span>Du</span>
        <input type="date" class="form-control" name="debut" [(ngModel)]="debut" />
      </label>
      <label class="pl-field">
        <span>Au</span>
        <input type="date" class="form-control" name="fin" [(ngModel)]="fin" />
      </label>
      <button type="submit" class="btn btn-outline-secondary" [disabled]="loading">Afficher</button>
    </form>

    <div class="pl-summary" *ngIf="items.length > 0">
      <span class="pl-rate">Remplissage <strong class="hgx-num">{{ tauxRemplissage }} %</strong></span>
      <span class="pl-refresh" *ngIf="actualisationAuto > 0 && derniereMiseAJour" title="Actualisation automatique">
        <i class="material-icons-outlined" aria-hidden="true">sync</i>{{ derniereMiseAJour | date: 'HH:mm' }}
      </span>
      <span class="pl-legend">
        <span class="pl-key"><i class="pl-swatch pl-bar--O"></i>Occupé</span>
        <span class="pl-key"><i class="pl-swatch pl-bar--C"></i>Confirmé</span>
        <span class="pl-key"><i class="pl-swatch pl-bar--R"></i>Réservé sans règlement</span>
        <span class="pl-key"><i class="pl-swatch pl-bar--M"></i>Maintenance</span>
      </span>
    </div>
  </div>

  <div class="pl-loading" *ngIf="loading">
    <div class="page-loader-spinner"><div class="page-loader-ring"></div></div>
    <span>Chargement du planning…</span>
  </div>

  <!-- Planning -->
  <div class="pl-scroll" *ngIf="!loading && items.length > 0">
    <table class="pl-table">
      <colgroup>
        <col class="pl-col-room" />
        <col *ngFor="let jour of jours" />
      </colgroup>
      <thead>
        <tr>
          <th class="pl-room-head" scope="col">{{ mode === 'espace' ? 'Espace' : mode === 'tout' ? 'Chambre ou espace' : 'Chambre' }}</th>
          <th *ngFor="let jour of jours; let i = index" scope="col" class="pl-day"
            [class.pl-weekend]="isWeekend(jour)" [class.pl-today]="isToday(jour)">
            <span class="pl-weekday">{{ formatJour(jour).weekday }}</span>
            <span class="pl-daynum">{{ formatJour(jour).day }}</span>
            <span class="pl-fill hgx-num" [class.pl-fill--full]="occupationParJour[i] === items.length"
              [title]="occupationParJour[i] + ' sur ' + items.length + ' pris'">
              {{ occupationParJour[i] }}/{{ items.length }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let groupe of groupes">
          <tr class="pl-group" *ngIf="groupes.length > 1 || groupe.libelle">
            <th [attr.colspan]="jours.length + 1" scope="rowgroup">{{ (groupe.libelle || 'Sans type') | titlecase }}</th>
          </tr>
          <tr *ngFor="let ligne of groupe.lignes">
            <th class="pl-room" scope="row">
              <span class="pl-room-name" [title]="ligne.item.libelle">{{ ligne.item.libelle | titlecase }}</span>
            </th>
            <ng-container *ngFor="let seg of ligne.segments">
              <td *ngIf="seg.statut === 'L'" class="pl-free"
                [class.pl-weekend]="isWeekend(seg.jour)" [class.pl-today]="isToday(seg.jour)">
                <button *ngIf="caseCreable(ligne.item, seg.jour)" type="button" class="pl-free-btn"
                  (click)="ouvrirMenuCase($event, ligne.item, seg.jour)"
                  [attr.aria-label]="(ligne.item.libelle | titlecase) + ', ' + formatJour(seg.jour).weekday + ' ' + formatJour(seg.jour).day + ' : réserver ou héberger'">
                  <i class="material-icons-outlined" aria-hidden="true">add</i>
                </button>
              </td>
              <td *ngIf="seg.statut !== 'L'" [attr.colspan]="seg.span" class="pl-busy"
                [class.pl-today]="isToday(seg.jour)">
                <button type="button" class="pl-bar pl-bar--{{ seg.statut }}"
                  [class.pl-bar--multi]="(seg.cell.count ?? 1) > 1"
                  (click)="$event.stopPropagation(); onCellClick($event, seg.cell, ligne.item, seg.jour, seg.span)"
                  [attr.aria-label]="getStatutLabel(seg.statut) + ' : ' + libelleCourt(seg.cell)"
                  [title]="getStatutLabel(seg.statut) + ' · ' + ((seg.cell.client || seg.cell.motif || '') | titlecase)">
                  {{ libelleCourt(seg.cell) }}
                </button>
              </td>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="pl-empty" *ngIf="!loading && items.length === 0 && jours.length > 0">
    {{ mode === 'espace' ? 'Aucun espace' : mode === 'tout' ? 'Aucune chambre ni espace' : 'Aucune chambre' }} pour cette période.
  </div>

  <!-- Création depuis une case libre -->
  <div class="pl-menu" *ngIf="menuCase.visible" [style.top.px]="menuCase.y" [style.left.px]="menuCase.x"
    [class.pl-bubble--dessus]="menuCase.dessus"
    (click)="$event.stopPropagation()" role="menu" aria-label="Créer">
    <div class="pl-menu-head">
      <strong>{{ menuCase.item?.libelle | titlecase }}</strong>
      <span>{{ formatJour(menuCase.jour || '').weekday }} {{ formatJour(menuCase.jour || '').day }}</span>
      <button type="button" class="pl-close" (click)="hideTooltip()" aria-label="Fermer">
        <i class="material-icons-outlined" aria-hidden="true">close</i>
      </button>
    </div>
    <button *ngIf="menuCase.peutReserver" type="button" role="menuitem" class="pl-menu-item" (click)="reserver()">
      <i class="material-icons-outlined" aria-hidden="true">event_available</i>Nouvelle réservation
    </button>
    <ng-container *ngIf="menuCase.formules.length">
      <div class="pl-menu-label">{{ estEspace(menuCase.item) ? 'Occuper maintenant' : 'Héberger maintenant' }}</div>
      <button *ngFor="let formule of menuCase.formules" type="button" role="menuitem" class="pl-menu-item"
        [disabled]="!plageFormule(formule).ouverte" (click)="heberger(formule)">
        <i class="material-icons-outlined" aria-hidden="true">login</i>{{ formule.libelle }}
        <span *ngIf="plageFormule(formule).horaires" class="pl-plage">{{ plageFormule(formule).horaires }}</span>
      </button>
    </ng-container>
    <p *ngIf="!menuCase.peutReserver && !menuCase.formules.length" class="pl-menu-empty">
      Vous n'avez pas les droits pour créer depuis le planning.
    </p>
  </div>

  <!-- Détail d'un séjour -->
  <div class="pl-tooltip" *ngIf="tt.visible" [style.top.px]="tt.y" [style.left.px]="tt.x" [class.pl-bubble--dessus]="tt.dessus" (click)="$event.stopPropagation()"
    role="dialog" aria-label="Détail">
    <div class="pl-tooltip-head">
      <strong>{{ tt.item?.libelle | titlecase }}</strong>
      <span>{{ formatJour(tt.jour || '').weekday }} {{ formatJour(tt.jour || '').day }}</span>
      <button type="button" class="pl-close" (click)="hideTooltip()" aria-label="Fermer">
        <i class="material-icons-outlined" aria-hidden="true">close</i>
      </button>
    </div>
    <div class="pl-sejour">
      <div class="pl-sejour-ligne">
        <span class="pl-swatch pl-bar--{{ tt.cell?.statut }}" [title]="getStatutLabel(tt.cell?.statut || '')"></span>
        <strong>{{ tt.cell?.statut === 'M' ? (tt.cell?.motif || 'Maintenance') : (tt.cell?.client | titlecase) }}</strong>
        <span class="pl-muted">· {{ getStatutLabel(tt.cell?.statut || '') }}<ng-container *ngIf="tt.cell?.service"> · {{ tt.cell?.service | titlecase }}</ng-container></span>
      </div>
      <div class="pl-sejour-dates hgx-num" *ngIf="tt.cell?.debut || tt.cell?.fin">
        {{ tt.cell?.debut }} → {{ tt.cell?.fin || '…' }}
      </div>
    </div>

    <ng-container *ngIf="peutFaireEntrer(tt.cell, tt.item) && !actionsSejour.chargement">
      <button type="button" class="btn btn-primary btn-sm pl-tooltip-action"
        [disabled]="!actionsSejour.entreePossible" [title]="actionsSejour.motifEntree || ''" (click)="faireEntrer(tt.cell, tt.item)">
        <i class="material-icons-outlined" aria-hidden="true">login</i>{{ estEspace(tt.item) ? "Démarrer l'occupation" : 'Faire entrer le client' }}
      </button>
      <p *ngIf="actionsSejour.motifEntree" class="pl-entree-impossible">
        <i class="material-icons-outlined" aria-hidden="true">schedule</i>{{ actionsSejour.motifEntree }}
      </p>
    </ng-container>

    <div class="pl-bloc" *ngIf="peutReserver(tt.item, tt.jour) || formulesHebergementChambre(tt.item).length">
      <button *ngIf="peutReserver(tt.item, tt.jour)" type="button" class="pl-menu-item" (click)="reserverSur(tt.item, tt.jour)">
        <i class="material-icons-outlined" aria-hidden="true">event_available</i>Nouvelle réservation
      </button>
      <div class="pl-heberger" *ngIf="formulesHebergementChambre(tt.item).length"
        [title]="barreCouvreAujourdhui() ? '' : 'Disponible uniquement sur la journée en cours'">
        <span class="pl-heberger-label"><i class="material-icons-outlined" aria-hidden="true">login</i>{{ estEspace(tt.item) ? 'Occuper' : 'Héberger' }}</span>
        <button *ngFor="let formule of formulesHebergementChambre(tt.item)" type="button" class="pl-chip"
          [disabled]="!plageFormule(formule).ouverte || !barreCouvreAujourdhui()"
          [title]="plageFormule(formule).horaires ? 'De ' + plageFormule(formule).horaires : ''"
          (click)="heberger(formule, tt.item)">{{ formule.libelle }}</button>
      </div>
    </div>

    <div class="pl-bloc pl-actions-grille" *ngIf="actionsSejour.chargement || actionsSejour.actions.length">
      <p *ngIf="actionsSejour.chargement" class="pl-muted">Chargement…</p>
      <button *ngFor="let action of actionsSejour.actions" type="button" class="pl-menu-item pl-menu-item--compact"
        [class.pl-menu-item--danger]="action.danger" (click)="executerAction(action)">
        <i class="material-icons-outlined" aria-hidden="true">{{ action.icone }}</i>{{ action.libelle }}
      </button>
    </div>
  </div>

  <!-- Réservations concurrentes sur un même jour -->
  <ng-template #detailModal let-modal>
    <div class="modal-header">
      <div>
        <h5 class="modal-title">{{ detail.chambre | titlecase }} · {{ detail.jour }}</h5>
        <p class="pl-modal-sub">{{ detail.items.length }} réservation{{ detail.items.length > 1 ? 's' : '' }} sur ce jour</p>
      </div>
      <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Fermer"></button>
    </div>
    <div class="modal-body p-0">
      <p *ngIf="detail.loading" class="pl-empty">Chargement…</p>
      <ng-container *ngIf="!detail.loading">
        <div *ngFor="let r of detail.items" class="pl-resa">
          <div>
            <strong>{{ r.client_nom | titlecase }} {{ r.client_prenom | titlecase }}</strong>
            <span class="pl-muted">{{ r.client_telephone }}</span>
          </div>
          <div class="pl-muted">
            {{ r.service_libelle | titlecase }} · {{ r.debut_reservation | date: 'dd/MM/yyyy' }} → {{ r.fin_reservation | date: 'dd/MM/yyyy' }}
          </div>
          <span class="hgx-badge" [class.hgx-badge--ok]="r.total_regle > 0" [class.hgx-badge--warn]="!(r.total_regle > 0)">
            {{ r.total_regle > 0 ? 'Réglé · ' + r.total_regle : 'Sans règlement' }}
          </span>
        </div>
        <p *ngIf="detail.items.length === 0" class="pl-empty">Aucune réservation trouvée</p>
      </ng-container>
    </div>
    <div class="modal-footer">
      <button *ngFor="let formule of formulesHebergement(detail.item, detail.jourIso)" type="button"
        class="btn btn-outline-secondary" [disabled]="!plageFormule(formule).ouverte" (click)="heberger(formule, detail.item)">Héberger · {{ formule.libelle }}</button>
      <button *ngIf="peutReserver(detail.item, detail.jourIso)" type="button"
        class="btn btn-outline-secondary me-auto" (click)="reserverSur(detail.item, detail.jourIso)">
        <i class="material-icons-outlined" aria-hidden="true">event_available</i>
        Ajouter une réservation
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Fermer</button>
    </div>
  </ng-template>
</div>
